/**
 * The language switch.
 *
 * A labelled button, not a flag. Flags stand for countries rather than languages,
 * and Arabic is spoken across many of them — a Kuwaiti flag would be wrong for the
 * language and odd for anyone else reading it. The label is the TARGET language in
 * its own script ("العربية" while in English, "English" while in Arabic), so it is
 * legible to exactly the person who wants to switch.
 */

import { useI18n } from "../i18n";
import { Icon } from "./icons";

export function LangToggle() {
  const { t, toggleLang, lang } = useI18n();
  return (
    <button
      type="button"
      className="lang-toggle"
      onClick={toggleLang}
      title={t("lang.label")}
      // The label is in the other language, so it needs that language's tag for a
      // screen reader to pronounce it with the right voice.
      lang={lang === "en" ? "ar" : "en"}
    >
      <Icon name="language" size={16} />
      <span>{t("lang.switch")}</span>
    </button>
  );
}
